export const hotSpringsData = [
  {
    id: 1,
    name: "Minneopa Springs Resort",
    location: "Minneopa State Park, Mankato",
    coordinates: { x: 45, y: 55 },
    temperature: "98-104°F",
    features: ["Natural mineral pools", "Hiking trails", "Waterfall views"],
    description:
      "Nestled near the historic Minneopa waterfalls, this serene hot spring offers therapeutic mineral waters surrounded by pristine Minnesota wilderness.",
    type: "Natural Spring",
    amenities: ["Spa services", "Restaurant", "Lodge"],
    rating: 4.8,
    image: "/images/minneopa-springs.webp",
  },
  {
    id: 2,
    name: "Blue Earth Thermal Spa",
    location: "Blue Earth County, Mankato",
    coordinates: { x: 52, y: 48 },
    temperature: "102-108°F",
    features: ["Indoor/outdoor pools", "Massage therapy", "Wellness center"],
    description:
      "A modern wellness retreat featuring naturally heated spring waters with high mineral content, perfect for relaxation and rejuvenation.",
    type: "Resort & Spa",
    amenities: ["Full spa", "Fitness center", "Dining", "Accommodation"],
    rating: 4.9,
    image: "/images/blue-earth-spa.webp",
  },
  {
    id: 3,
    name: "River Bend Hot Springs",
    location: "Minnesota River Valley",
    coordinates: { x: 38, y: 62 },
    temperature: "96-102°F",
    features: ["Riverside location", "Natural rock pools", "Stargazing deck"],
    description:
      "Experience the tranquility of natural hot springs along the Minnesota River, with authentic rock-lined pools and panoramic valley views.",
    type: "Natural Spring",
    amenities: ["Changing rooms", "Picnic areas", "Trail access"],
    rating: 4.7,
    image: "/images/river-bend-springs.webp",
  },
  {
    id: 4,
    name: "Prairie Winds Thermal Resort",
    location: "New Ulm Area",
    coordinates: { x: 28, y: 40 },
    temperature: "100-106°F",
    features: ["Prairie views", "Therapeutic treatments", "Family-friendly"],
    description:
      "Set against the backdrop of Minnesota's beautiful prairie landscape, offering family-friendly hot spring experiences with modern amenities.",
    type: "Resort & Spa",
    amenities: ["Pool complex", "Spa treatments", "Restaurant", "Event space"],
    rating: 4.6,
    image: "/images/prairie-winds.webp",
  },
  {
    id: 5,
    name: "Sakatah Springs Sanctuary",
    location: "Sakatah Lake State Park",
    coordinates: { x: 65, y: 35 },
    temperature: "94-100°F",
    features: ["Lake views", "Wildlife watching", "Secluded pools"],
    description:
      "A hidden gem offering intimate hot spring pools with stunning lake views and abundant wildlife in a peaceful, natural setting.",
    type: "Natural Spring",
    amenities: ["Trails", "Wildlife viewing", "Quiet zones"],
    rating: 4.5,
    image: "/images/sakatah-springs.webp",
  },
  {
    id: 6,
    name: "Red Jacket Trail Springs",
    location: "Red Jacket Trail, Mankato",
    coordinates: { x: 50, y: 60 },
    temperature: "100-104°F",
    features: ["Bike trail access", "Wooded soaking decks", "Bird‑watching"],
    description:
      "Tucked just off the famed Red Jacket Trail, these springs provide cyclists and hikers a refreshing geothermal stopover amid lush river bluffs.",
    type: "Natural Spring",
    amenities: ["Bike racks", "Snack kiosk", "Locker rentals"],
    rating: 4.7,
    image: "/images/red-jacket-springs.webp",
  },
  {
    id: 7,
    name: "Eagle Lake Mineral Baths",
    location: "Eagle Lake Township",
    coordinates: { x: 60, y: 40 },
    temperature: "97-103°F",
    features: ["Lakeside pools", "Sauna cabin", "Fishing pier nearby"],
    description:
      "Gentle mineral waters meet crystal‑clear Eagle Lake vistas—perfect for sunset soaks followed by a classic Finnish‑style sauna session.",
    type: "Lakeside Spring",
    amenities: ["Sauna", "Kayak rentals", "Campground access"],
    rating: 4.6,
    image: "/images/eagle-lake-baths.webp",
  },
  {
    id: 8,
    name: "Rapidan Dam Hot Springs",
    location: "Rapidan Township",
    coordinates: { x: 35, y: 70 },
    temperature: "101-107°F",
    features: ["Dam overlook", "Rock‑rimmed pools", "Fall foliage views"],
    description:
      "Perched below the historic Rapidan Dam, these rock‑rimmed pools harness geothermal vents beneath the riverbed—spectacular in autumn colors.",
    type: "Riverside Spring",
    amenities: ["Viewing platform", "Picnic shelter", "Trailhead parking"],
    rating: 4.8,
    image: "/images/rapidan-springs.webp",
  },
  {
    id: 9,
    name: "Madison Lake Serenity Spa",
    location: "Madison Lake",
    coordinates: { x: 62, y: 45 },
    temperature: "95-101°F",
    features: ["Infinity hot pool", "Aromatherapy garden", "Yoga deck"],
    description:
      "A boutique wellness spot blending geothermal waters with curated aromatherapy gardens and sunrise yoga overlooking Madison Lake.",
    type: "Resort & Spa",
    amenities: ["Yoga classes", "Juice bar", "Boutique lodging"],
    rating: 4.9,
    image: "/images/madison-lake-spa.webp",
  },
  {
    id: 10,
    name: "Garden City Geothermal Retreat",
    location: "Garden City",
    coordinates: { x: 42, y: 68 },
    temperature: "98-105°F",
    features: [
      "Geodesic greenhouse pools",
      "Farm‑to‑table café",
      "Orchard walks",
    ],
    description:
      "Soak beneath a glass dome surrounded by year‑round greenery, then savor produce grown on‑site at the adjoining farm‑to‑table café.",
    type: "Eco Retreat",
    amenities: ["Greenhouse pools", "Café", "Orchard tours"],
    rating: 4.7,
    image: "/images/garden-city-retreat.webp",
  },
  {
    id: 11,
    name: "Lake Crystal Healing Waters",
    location: "Lake Crystal",
    coordinates: { x: 40, y: 55 },
    temperature: "96-102°F",
    features: ["Crystal‑clear pools", "Meditation docks", "Paddleboard access"],
    description:
      "Known for remarkably clear mineral water, this site pairs tranquil dockside meditation zones with stand‑up paddle soaks at sunset.",
    type: "Lakeside Spring",
    amenities: ["Meditation platforms", "SUP rentals", "Tea house"],
    rating: 4.6,
    image: "/images/lake-crystal-waters.webp",
  },
  {
    id: 12,
    name: "Le Hillier Artesian Hot Pool",
    location: "Le Hillier, South Bend Township",
    coordinates: { x: 48, y: 52 },
    temperature: "99-103°F",
    features: ["Burbling artesian well", "Stone grotto", "Evening light shows"],
    description:
      "A naturally pressurized artesian spring feeds a stone‑grotto pool—ambient lighting transforms nightly into a shimmering aqua spectacle.",
    type: "Artesian Spring",
    amenities: ["Changing grotto", "Evening illuminations", "Snack bar"],
    rating: 4.5,
    image: "/images/le-hillier-pool.webp",
  },
  {
    id: 13,
    name: "Minneopa Bluffs Soak",
    location: "Minneopa Bluffs, Mankato",
    coordinates: { x: 46, y: 57 },
    temperature: "97-104°F",
    features: ["Bluff‑top tubs", "Bison range overlook", "Stargazing hammocks"],
    description:
      "Perch above the Minneopa bison enclosure while soaking in cliff‑edge tubs—night sessions include hammocks for unrivaled prairie stargazing.",
    type: "Scenic Spring",
    amenities: ["Hammock rentals", "Guided night hikes", "Fire pits"],
    rating: 4.8,
    image: "/images/minneopa-bluffs.webp",
  },
  {
    id: 14,
    name: "Indian Lake Natural Springs",
    location: "Indian Lake Township",
    coordinates: { x: 58, y: 38 },
    temperature: "94-100°F",
    features: ["Wildflower meadows", "Quiet soaking circles", "Bird blinds"],
    description:
      "Small, intimate pools set within native wildflower meadows—ideal for quiet reflection and prime bird‑watching from nearby blinds.",
    type: "Natural Spring",
    amenities: ["Bird blinds", "Meadow trails", "Silent zones"],
    rating: 4.4,
    image: "/images/indian-lake-springs.webp",
  },
  {
    id: 15,
    name: "Judson Creek Thermal Oasis",
    location: "Judson Township",
    coordinates: { x: 30, y: 60 },
    temperature: "100-106°F",
    features: ["Creekside terraces", "Hot‑cold plunge", "Forest canopy walks"],
    description:
      "Terraced hot pools carved along Judson Creek pair with cold‑plunge basins and an elevated canopy walk winding through mature hardwoods.",
    type: "Forest Spring",
    amenities: ["Plunge pools", "Canopy walk", "Coffee hut"],
    rating: 4.7,
    image: "/images/judson-creek-oasis.webp",
  },
  {
    id: 16,
    name: "Sibley Park Hot Springs",
    location: "Sibley Park, Mankato",
    coordinates: { x: 45, y: 50 },
    temperature: "96-102°F",
    features: ["Park setting", "River views", "Family-friendly"],
    description:
      "Located in beautiful Sibley Park, these hot springs offer relaxing mineral waters with scenic river views and easy access to park amenities.",
    type: "Park Spring",
    amenities: ["Picnic areas", "Playground nearby", "Walking paths"],
    rating: 4.6,
    image: "/images/sibley.jpg",
  },
];

export const mapRegions = {
  center: { x: 47, y: 47 },
  bounds: {
    north: 20,
    south: 75,
    east: 75,
    west: 20,
  },
};
